import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  actionMenuButton: {
    padding: theme.spacing(0)
  },
  lock: {
    '& label': {
      margin: theme.spacing(0)
    },
    '& .MuiFormControlLabel-label': {
      fontSize: theme.typography.pxToRem(14)
    }
  },
  buttonAction: {
    borderRadius: theme.spacing(0),
    border: `none`,
    color: theme.palette.text.primary,
    backgroundColor: 'transparent',
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: 1.43,
    textAlign: 'left',
    padding: theme.spacing(1.5, 2.5),
    width: '100%',
    justifyContent: 'flex-start',
    borderBottom: `1px solid ${theme.palette.colors.border}`,
    '& i, & svg': {
      marginRight: theme.spacing(1.5),
      fontSize: theme.typography.pxToRem(16)
    },
    '& strong': {
      marginLeft: theme.spacing(0.5)
    },
    '&:hover': {
      color: theme.palette.secondary.main,
      backgroundColor: 'transparent'
    },
    '&.approve-initially, &.approve-finally, &.approve, &.confirm-car-receive, &.return-to-car-company, &.return-to-last-state': {
      '&:hover': {
        color: theme.palette.success.main
      }
    },
    '&.reject, &.cancel, &.terminate, &.suspend': {
      '&:hover': {
        color: theme.palette.error.main
      }
    }
  }
}))
